module.exports = {
        srcSet: __webpack_public_path__ + "ec8e1b7d3f130e94-500.webp"+" 500w",
        images: [{path: __webpack_public_path__ + "ec8e1b7d3f130e94-500.webp",width: 500,height: 320}],
        src: __webpack_public_path__ + "ec8e1b7d3f130e94-500.webp",
        toString: function(){return __webpack_public_path__ + "ec8e1b7d3f130e94-500.webp"},
        
        width: 500,
        height: 320
      }